export enum LegalEntityFormFieldNames {
  CompanyName = 'companyName',
  CompanyRole = 'companyRole',
  CompanyType = 'companyType',
  Contacts = 'contacts',
  Financials = 'financials',
}
